import Vue from 'vue'
import Router from 'vue-router'
import routers from './router'
import constRouters from './constRouter'
import index from '../pages/index/index'
import layout from '../layouts/index'
import brief from '../pages/brief/index'//园区简介
import servicelist from '../pages/service/servicelist'//公共服务
import enterprise from '../pages/enterprise/enterprise'//园区企业
import policy from '../pages/policy/policy'//本地政策'
import information from '../pages/dataview/information'//数据大屏
import about from '../pages/about/about'//关于我们
import listpage from '../pages/common/listpage'//首页列表
import detail from '../pages/common/detail'//详情
import enterprisedetail from '../pages/common/enterprisedetail'//企业详情
import comdetail from '../pages/company/comdetail'//企业详情02
import policydetail from '../pages/common/policydetail'//政策详情

import bulletinlist from '../pages/bulletin/list'//政策咨询
Vue.use(Router) //vue全局使用Router
export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			component: index,  

		}, 
		{
			path: '/body',
			component: layout, 
			meta: {
				title: '',
				content: {
					keywords: '',
					description: ''
				}
			},
			children: [
				{
				path: '/index',
				name: 'index',
				component: index,
			},
			{
				path: '/brief',
				name: 'brief',
				component: brief,
			},{
				path: '/servicelist',
				name: 'servicelist',
				component: servicelist,
			},{
				path: '/enterprise',
				name: 'enterprise',
				component: enterprise,
			},{
				path: '/policy',
				name: 'policy',
				component: policy,
			},{
				path: '/about',
				name: 'about',
				component: about,
			},
			{
				path: '/listpage',
				name: 'listpage',
				component: listpage,
			},{
				path: '/detail',
				name: 'detail',
				component: detail,
			},{
				path: '/enterprisedetail',
				name: 'enterprisedetail',
				component: comdetail,
			},{
				path: '/policydetail',
				name: 'policydetail',
				component: policydetail,
			},{
				path: '/bulletinlist',
				name: 'bulletinlist',
				component: bulletinlist,
			}],
		},
		{
			path: '/information',
			name: 'information',
			component: information,
		},
		// {
		// 	path: '/information',
		// 	name: 'information',
		// 	component: information,
		// }
	 
		 
	], 
	scrollBehavior(to, from, savedPosition) {
		return {
			x: 0,
			y: 0
		}
	}
})

function exportWhiteListFromRouter(router) {
	let res = []
	for (let item of router)
		res.push(item.path)
	return res
}
let router = new Router({
	mode: 'history',
	routes: constRouters
})

function save(name, data) {
	localStorage.setItem(name, JSON.stringify(data))
}
router.addRoutes(routers)
// 路由白名单
const whiteList = exportWhiteListFromRouter(constRouters)



// WEBPACK FOOTER //
// ./src/router/index.js